/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_An_IssueInputs */

const en_report_an_issue = /** @type {(inputs: Report_An_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report an issue`)
};

const nl_report_an_issue = /** @type {(inputs: Report_An_IssueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld een probleem`)
};

/**
* | output |
* | --- |
* | "Report an issue" |
*
* @param {Report_An_IssueInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const report_an_issue = /** @type {((inputs?: Report_An_IssueInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_An_IssueInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_report_an_issue(inputs)
	return en_report_an_issue(inputs)
});